import React, {useEffect, useState} from "react";
import { Outlet, Link ,useParams, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { decrpt } from "../../components/Slider/encryption";
import axios from "axios";

// import { AiOutlineCheckCircle } from "react-icons/ai";
// import { BsTrash} from "react-icons/bs";

function ConfirmCOD({route}) {
  const [paymentData , setPaymentData] = useState([]);
  const [showData , setShowData] = useState();
  const location = useLocation()
  const params=useParams();
  const {orderidcookie} =params;
  // console.log(orderidcookie,'1');
  // console.log(params,'2');
  // console.log(route,'3');
  // console.log(location,'4');
  // console.log({orderidcookie},'gggggggg')


  // console.log(paymentData && paymentData , 'paymentData');

  const updateAndRun = async() => {
    let getCookies = orderidcookie.replace(/\..+/, '').split('_');
      await  setPaymentData(getCookies);
      paymentVerify(getCookies);
  }


  
useEffect(() => {
  if(location.state != null){
    setShowData(location.state.data.order_id);
  }else {
    updateAndRun();
  }
},[])

const  paymentVerify = (getCookies) => {
  try {
    console.log(getCookies && getCookies[0] ,'getCookies');
    let loki = Cookies.get("ordercookie");
    // console.log(loki , 'loki');
    const data = {
      payment_status: getCookies[0],
      payment_id: getCookies[1],
      id: loki && loki
    }
    let token = decrpt(Cookies.get('s_l'));
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
			const response = axios.post('/user/order/make/payment/id', data)
				.then(ress => {
					// console.log("postdata", ress);
          setShowData(ress.data.data.order_uuid)
          }
				)
			// console.log(response, 'response2')

		} catch (error) {
			// console.log(error);
		} 
  }
	

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="responsive-xs responsive-md-lg responsive-sm">
      {/* Produt List */}
      <section className="light-grey">
        <div className="container">
          {/* PageNav  */}
          <div className="order-pagination">
            <ul>
              <li>Cart</li>
              <li>Checkout</li>
              <li style={{color: '#0eb90e'}}>Confirmation</li>
            </ul>
          </div>
          
          {/* Cart */}
          <div className="section-main-confirm">
            <div className="text1">Thank You</div>
            <div className="text2">Your Order is placed </div>
            <div className="text3">Your Order no is {showData && showData }. You will receive all text and a mail to your registered phone number and E-mail id. if you have any order related query, please send us an email or call us on +91 6003236591.</div>
            <div className="confirm-btn">
              <Link to="/">Go To Homepage</Link>
              <Link to="../your-account/orders">My Order</Link>
            </div>
          </div>
        </div>
      </section>
      <Outlet />
    </div>
  );
}

export default ConfirmCOD;




// import { useParams } from 'react-router-dom'
// import React from 'react'
// const Confirm = () => {
  
//   const params=useParams
//   const {orderidcookie} =params()
//   console.log({orderidcookie},'gggggggg')
//   return (
//     <div>ppppoooollllaaaabbbb</div>
//   )
// }

// export default Confirm
